<template>
    <div>
        <label class="form-label" :for="uniqueName">
            {{ label }}
        </label>

        <div
            v-for="(option, index) in checkboxes"
            :key="index"
            class="form-checkbox__option"
        >
            <input
                :id="option.name"
                v-model="option.checked"
                class="form-checkbox"
                type="checkbox"
                :disabled="disabled"
                :name="name"
                :value="option.name"
                @change="onChange"
            />
            <label
                class="form-checkbox__label"
                :class="{ 'form-checkbox__label--error': error }"
                :for="option.name"
            >
                {{ option.name }}
            </label>
        </div>

        <span
            class="input__error pl-4"
            :class="{ 'input__error--visible': error }"
        >
            {{ error }}
        </span>
    </div>
</template>

<script>
import FormComponentMixin from '@/js/mixins/form-component-mixin';

export default {
    mixins: [FormComponentMixin],
    props: {
        options: {
            type: Array,
            default() {
                return [];
            }
        }
    },
    data() {
        return {
            checkboxes: [],
            value: []
        };
    },
    created() {
        const checkboxes = [];
        this.options.forEach(function(item) {
            checkboxes.push({ name: item.name, checked: item.checked });
        });
        this.checkboxes = checkboxes;
    },
    methods: {
        onChange() {
            const value = [];
            this.checkboxes.forEach(function(item) {
                if (item.checked) {
                    value.push(item.name);
                    item.checked = true;
                } else {
                    item.checked = false;
                }
            });
            this.value = value;
            this.$emit('input', this.value);
        }
    }
};
</script>
